
export enum InvoiceTransmissionFormatCd {
	INVOICE = 'Invoice',
	MANIFEST = 'Manifest',
	STATEMENT = 'Statement'}

